import { gql } from '@apollo/client';

export const ASSIGN_DATA_SOURCE = gql`
mutation DQassignDataSource($batchId: Int, $fileId: Int, $reportId: Int!, $reportPeriod: String) {
    DQassignDataSource(batchId: $batchId, fileId: $fileId, reportId: $reportId, reportPeriod: $reportPeriod) {
      success
    }
}`;

export const ADD_LATER = '';
